import {useConfigContext} from '../../../contexts/ConfigContext'

export const usePassportUrl = (path: string): string => {
  const {lang, passportAppID, passportHost} = useConfigContext()

  const url = new URL(path, passportHost)

  url.searchParams.append('retpath', window?.location.href)
  url.searchParams.append('lang', lang)
  passportAppID && url.searchParams.append('origin', passportAppID)

  return url.toString()
}
